module.exports = __webpack_public_path__ + "static/media/international19.9a07d447.jpeg";